import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// components
import Modal from "react-bootstrap/Modal";

// styles
import ModalStyles from "../DashboardReuseAbleComponents/Modal.module.css";

export default function LogoutModal(props) {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [btnLoader, setBtnLoader] = React.useState(false);

  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
        {/* 
                    // height: 671px;
             */}
      </style>
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>خروج از حساب کاربری</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 d-flex align-items-center justify-content-center flex-column mt-2 mb-3 text-end">
            <div className="d-flex align-items-center justify-content-center mt-3">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M30.5498 28.6744L34.8491 24.375L13.1254 24.375C12.6281 24.375 12.1512 24.1775 11.7996 23.8258C11.4479 23.4742 11.2504 22.9973 11.2504 22.5C11.2504 22.0027 11.4479 21.5258 11.7996 21.1742C12.1512 20.8225 12.6281 20.625 13.1254 20.625L34.8491 20.625L30.5498 16.3256C30.3707 16.1527 30.2279 15.9458 30.1296 15.717C30.0313 15.4882 29.9796 15.2422 29.9774 14.9933C29.9753 14.7443 30.0227 14.4974 30.117 14.267C30.2113 14.0365 30.3505 13.8272 30.5265 13.6511C30.7026 13.4751 30.9119 13.3359 31.1424 13.2416C31.3728 13.1473 31.6197 13.0999 31.8687 13.102C32.1176 13.1042 32.3636 13.1559 32.5924 13.2542C32.8212 13.3525 33.0281 13.4953 33.201 13.6744L40.701 21.1744C41.0525 21.526 41.25 22.0028 41.25 22.5C41.25 22.9972 41.0525 23.474 40.701 23.8256L33.201 31.3256C33.0281 31.5047 32.8212 31.6475 32.5924 31.7458C32.3637 31.8441 32.1176 31.8958 31.8687 31.898C31.6197 31.9001 31.3728 31.8527 31.1424 31.7584C30.9119 31.6641 30.7026 31.5249 30.5265 31.3489C30.3505 31.1728 30.2113 30.9635 30.117 30.733C30.0227 30.5026 29.9753 30.2557 29.9774 30.0067C29.9796 29.7578 30.0313 29.5117 30.1296 29.283C30.2279 29.0542 30.3707 28.8473 30.5498 28.6744ZM5.6254 43.125L20.6254 43.125C21.1227 43.125 21.5996 42.9275 21.9512 42.5758C22.3029 42.2242 22.5004 41.7473 22.5004 41.25C22.5004 40.7527 22.3029 40.2758 21.9512 39.9242C21.5996 39.5725 21.1227 39.375 20.6254 39.375L7.5004 39.375L7.5004 5.625L20.6254 5.625C21.1227 5.625 21.5996 5.42746 21.9512 5.07583C22.3029 4.7242 22.5004 4.24728 22.5004 3.75C22.5004 3.25272 22.3029 2.7758 21.9512 2.42417C21.5996 2.07254 21.1227 1.875 20.6254 1.875L5.6254 1.875C5.12812 1.875 4.65121 2.07254 4.29958 2.42417C3.94794 2.77581 3.7504 3.25272 3.7504 3.75L3.7504 41.25C3.7504 41.7473 3.94795 42.2242 4.29958 42.5758C4.65121 42.9275 5.12812 43.125 5.6254 43.125Z"
                  fill="#FF0000"
                />
              </svg>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-3">
              <div className={ModalStyles.title}>آیا برای خروج از حساب کاربری خود اطمینان دارید؟</div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`} onClick={props.onHide}>
              انصراف
            </div>

            {btnLoader ? (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`}>
                <div className={ModalStyles.btn_loader_container}>
                  <div className={ModalStyles.btn_spinner}></div>
                </div>
              </div>
            ) : (
              <div className={`d-flex align-items-center justify-content-center ms-3 bg-danger ${ModalStyles.filled_btn}`} onClick={logoutHandler}>
                خروج
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  async function logoutHandler() {
    setBtnLoader(true);
    try {
      const apiData = await axios.delete("Auth/logout", {
        headers: { authorization: "Bearer " + userToken },
      });
    } catch {}
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    // localStorage.removeItem("fullName");
    // localStorage.removeItem("avatar");
    // localStorage.removeItem("id");
    // localStorage.removeItem("data");
    // localStorage.removeItem("roles");
    // localStorage.removeItem("email");
    // localStorage.removeItem("phoneNumber");
    // localStorage.removeItem("name");
    // localStorage.removeItem("creationDate");
    // localStorage.removeItem("isActive");
    // localStorage.removeItem("family");
    setBtnLoader(false);
    history.push("/");
    window.location.reload(false);
    props.onHide();
  }
}
